import React from 'react';
import AppRouter from './app/AppRouter';
import './styles/auth.css';
import './styles/viewer.css';

function App() {
  return <AppRouter />;
}

export default App;
